const UINT8_MAX_VALUE = 255;
const UINT16_MAX_VALUE = 65535
const INT32_MAX_VALUE = 2147483647;
const INT32_MIN_VALUE = -2147483648;
const UINT32_MAX_VALUE = 4294967295;
const INT64_MAX_VALUE = BigInt("9223372036854775807");
const INT64_MIN_VALUE = BigInt("-9223372036854775808");
const UINT64_MAX_VALUE = BigInt("18446744073709551615");
export {INT32_MAX_VALUE, INT32_MIN_VALUE, INT64_MAX_VALUE, INT64_MIN_VALUE, UINT32_MAX_VALUE, UINT64_MAX_VALUE, UINT8_MAX_VALUE, UINT16_MAX_VALUE };
